// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 8450) return "static/chunks/8450-847410ce743191c5.js";
	if (chunkId === 2212) return "static/chunks/2212-724c8e3d6cd9c91d.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1808 ? "dd9fe092" : chunkId) + "." + {"1808":"33de7abbfe17654a","2788":"4493953b6e4759b3","3444":"4a47aa203df69cf4","4423":"7d0df8e0cb1c265e","5374":"82f16d27486ff640","6601":"27be05139d38f27b","7025":"de91dc71028a7651"}[chunkId] + ".js";
};